import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { CategoriesService } from '../../services/categories.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
  public uploader: FileUploader = new FileUploader({});
  categories:any = [];
  categoryForm:FormGroup;

  cancellationReason: boolean;
  cancellationArray:any = [];
  submitted = false;
  


  constructor(private formBuilder: FormBuilder, private categoriesService: CategoriesService) { }
 
  ngOnInit(): void {
    this.categoryForm = this.formBuilder.group({
      name: '',
      // img: [null]
      img: ''
    });
    this.categoriesService.getAllCategories().then((res: any) => {
      console.log(res)
      this.categories = (res.categories);
    })
  }


  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }
  url;
  msg = "";

  selectFile(event) {

    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }

    const file = (event.target as HTMLInputElement).files[0];
    this.categoryForm.patchValue({
      img: file
    });

    this.categoryForm.get('img').updateValueAndValidity();
  }

  submitCategory() {

    var formData: FormData = new FormData();

    formData.append("name", this.categoryForm.get('name').value);
    formData.append("image", this.categoryForm.get('img').value);

    this.categoriesService.addCategory(formData).then((res: any) => {
      console.log(res)
      this.categoryForm.reset()
      this.categoriesService.getAllCategories().then((res: any) => {
        console.log(res)
        this.categories = (res.categories);
      })
    })
    
  }

  deleteCategory() {
    this.categoriesService.removeCategory(this.cancellationArray.id).then((res: any) => {
      console.log(res)
      this.categoriesService.getAllCategories().then((res: any) => {
        console.log(res)
        this.categories = (res.categories);
      })
      this.cancellationReason = false;
    })
    
  }

  showCancellation(id) {
    this.cancellationReason = true;
    this.cancellationArray.id = id;
    console.log(this.cancellationArray.id)
  
  }
  
  hideCancellation() {
    this.cancellationReason = false;
    this.submitted = false;
  }

  


}
